import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import MaterialButton from "../../../components/MaterialButton";
import GoogleMapKey from "../../../pages/Utils/googleMapKey";

const containerStyle = {
  width: "100%",
  height: "400px",
};

const defaultCenter = { lat: 26.0667, lng: 50.5577 };
const Location = ({ open, onClose, onSelectLocation, selectedLatLng }) => {
  const [marker, setMarker] = useState(selectedLatLng || defaultCenter);

  useEffect(() => {
    if (selectedLatLng?.lat && selectedLatLng?.lng) {
      setMarker(selectedLatLng);
    } else {
      setMarker(defaultCenter);
    }
  }, [selectedLatLng]);

  const handleMapClick = async (e) => {
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();

    // Fetch human-readable address using Google Maps Geocoder
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        const address = results[0].formatted_address;
        setMarker({ lat, lng, address });
      } else {
        setMarker({ lat, lng, address: `Lat: ${lat}, Lng: ${lng}` });
      }
    });
  };

  const handleSelect = () => {
    if (marker) {
      onSelectLocation(marker);
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Select Location</DialogTitle>
      <DialogContent>
        <LoadScript googleMapsApiKey={GoogleMapKey} libraries={["places"]}>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={
              marker?.lat && marker?.lng
                ? { lat: marker.lat, lng: marker.lng }
                : { lat: 12.9716, lng: 77.5946 }
            }
            zoom={15}
            onClick={handleMapClick}
          >
            {marker && (
              <Marker position={{ lat: marker.lat, lng: marker.lng }} />
            )}
          </GoogleMap>
        </LoadScript>
        {marker?.address && (
          <p style={{ marginTop: "10px", fontWeight: "bold" }}>
            Selected Address: {marker.address}
          </p>
        )}
      </DialogContent>
      <DialogActions>
        <MaterialButton onClick={onClose}>Cancel</MaterialButton>
        <MaterialButton onClick={handleSelect}>Select</MaterialButton>
      </DialogActions>
    </Dialog>
  );
};

export default Location;
